<template>
  <v-app style="height: 100vh">
    <LayoutBroker
      :layouts="$options.layouts"
      :current="$route.meta.layout"
    />
    <SnackbarsBroker
      default-x="right"
      default-y="top"
      default-color="success darken-2"
      :default-timeout="5000"
    />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutBroker from 'vue-layout-broker'
import layouts from '@/layouts'
import SnackbarsBroker from '@/components/snackbars-broker'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
  layouts,
  name: 'App',
  components: {
    LayoutBroker,
    SnackbarsBroker
  },
  computed: {
    ...mapGetters('ui', [
      'darkThemeEnabled'
    ])
  },
  watch: {
    darkThemeEnabled (val) {
      this.$vuetify.theme.dark = val
    }
  },
  async created () {
    this.$vuetify.theme.dark = this.darkThemeEnabled
    const fpPromise = FingerprintJS.load()
    const fp = await fpPromise
    this.$eh.visitorId = await fp.get()
  }
}
</script>
